<template>
    <div class="input-group d-flex justify-content-end">
        <slot name="before"></slot>
        <input
            ref="searchInput"
            v-model="searchText"
            class="form-control rounded-left"
            name="search"
            :placeholder="placeholder"
            @keyup.enter="updateText"
            @input="debouncedSearch"
            :disabled="isDisabled"
            :class="[
                stretchSize ? '' : 'col-md-5',
                { 'cursor-not-allowed': isDisabled }
            ]"
            type="search"
        />
        <div class="input-group-append">
            <button
                type="button"
                class="btn btn-secondary rounded-right"
                v-b-tooltip.hover.top
                :title="placeholder"
                @click="updateText"
                :disabled="isDisabled"
                :class="{ 'cursor-not-allowed': isDisabled }"
            >
                <i class="fas fa-search"></i>
            </button>
        </div>
        <slot name="after"></slot>
    </div>
</template>

<script>
import { debounce } from "lodash";

export default {
    components: {},
    props: {
        value: {
            type: String,
            default: null
        },
        settingTemplate: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "Search template"
        },
        debouncetime: {
            type: Number,
            default: 700
        },
        stretchSize: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchText: this.value,
            debouncedSearch: null // Temporary placeholder
        };
    },
    watch: {
        value(newValue) {
            this.searchText = newValue;
        }
    },
    created() {
        // initialize debouncedSearch with the correct debouncetime
        this.debouncedSearch = debounce(() => {
            this.updateText();
        }, this.debouncetime);
    },
    methods: {
        updateText() {
            if (this.debouncedSearch) {
                this.debouncedSearch.cancel();
            }
            this.$emit("search", this.searchText);
        },
        resetSearch() {
            this.searchText = null;
        }
    }
};
</script>
<style scoped>
.rounded-left {
    border-top-left-radius: 4.5px;
    border-bottom-left-radius: 4.5px;
}

.rounded-right {
    border-top-right-radius: 4.5px;
    border-bottom-right-radius: 4.5px;
}

.search-input::-webkit-search-cancel-button {
    cursor: pointer;
}
</style>
